import PageTitle from '../../../components/PageTitle';
import { Progress, TooltipV2 } from '@cimplico/components';
import { ShareIcon } from '@heroicons/react/24/outline';
import plural from '../../../utilities/plural';

type CalculationInfoProps = {
    name: string;
    description: string | null;
    progress: number;
    worksheets: { id: string; name: string }[];
};

function CalculationInfo({ name, description, progress, worksheets }: CalculationInfoProps): JSX.Element {
    return (
        <>
            <PageTitle title={name} />
            <p className="max-w-[800px] text-gray-600 text-sm">{description}</p>
            <div className="flex gap-2 items-center shrink-0 flex-wrap  ">
                <Progress type="circle" percent={progress} showProgressLabel size="small" />
                <div className="h-1 w-1 bg-gray-500 rounded-full"></div>
                <div>
                    <div className="flex items-center gap-1">
                        <ShareIcon className="text-gray-600 h-4 w-4" />
                        <label className="text-xs text-gray-500">
                            <TooltipV2 message={worksheets.map((ws) => ws.name)} disabled={worksheets.length === 0}>
                                {worksheets.length} {plural(worksheets.length, 'worksheet')}
                            </TooltipV2>
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CalculationInfo;
